var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pie-wrapper",on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{ref:"myPie",staticClass:"pie-inner"})])
}
var staticRenderFns = []

export { render, staticRenderFns }